import { Box, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useEffect, useState } from 'react'
import { AccordionComponent } from '../../components/Accordion/Accordion'
import { Approver } from '../../components/Approver/Approver'
import { Footer } from '../../components/Footer/Footer'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { copyObj } from '../../services/Helper'
import { EventType, Staff, StaffType, Role } from '../../services/Types'
import { appTheme } from '../../theme'
import { root, container } from '../../global'
import { useStyles } from './style'
import { useNavigate, useParams } from 'react-router-dom'
import {
  getStaff,
  createUpdateStaff,
  eventDetail,
  updateTBD
} from '../../services/EventService'
import { ErrorMessage } from '../../components/ErrorMessage/ErrorMessage'
import SpeakersAndSupportStaff from '../../images/speakersAndSupportStaff.svg'
import { EventTitle } from '../../components/EventTitle/EventTitle'
import { PageTitle } from '../../components/PageTitle/PageTitle'
import moment from 'moment'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

var isWebView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, '96px', 3, '96px') }
    : { padding: theme.spacing(0, 4, '96px', 4) }
)

export default function SpeakerAndStaffSupportPage() {
  let { id } = useParams()
  const navigate = useNavigate()
  const classes = useStyles()
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))

  const [showErrorMessage, setErrorMessage] = useState('')
  const [presenterErrors, setPresenterErrors] = useState<number[]>([])
  const [moderatorErrors, setModeratorErrors] = useState<number[]>([])

  const [tbd_presenters, setTbdPresenters] = useState(0)
  const [tbd_moderators, setTbdModerators] = useState(0)
  const [tbd_supportstaff, setTbdSupportstaff] = useState(0)

  const [staff, setStaff] = useState<Staff[]>([])
  const [event, setEvent] = useState<any>({
    overHundredParticipants: true,
    sendInvitation: 'OWN',
    invitationDistributionList: '',
    invitationNotes: ''
  })

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            let eventData = data.eventDetail.data
            if (eventData === null) {
              return navigate('/')
            }
            if (eventData.creater.id !== user.id && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            if (eventData.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            let liveRoomBooking = eventData.roomBooking?.find((x: any) => x.category === 'live')
            if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            setEvent(data.eventDetail.data)
          }
        }
      } catch (error) {
        showErrorPopup('Internal server error')
      }
    }

    if (id !== undefined) {
      loadEventData()
    }

    const loadStaff = async () => {
      const results = await getStaff(Number(id))
      const { data } = results
      setStaff(data.staff.data)
    }
    if (id !== undefined) {
      loadStaff()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleStaffChange = (updatedStaff: Staff[], staff_type: StaffType) => {
    let newStaff: Staff[] = copyObj(staff)
    newStaff = newStaff.filter(s => s.staff_type !== staff_type)
    newStaff = [...newStaff, ...updatedStaff]
    setStaff(newStaff)
  }

  const backClick = async () => {
    navigate('/event/info/' + id)
  }

  const updateTbd = async () => {
    try {
      const results = await updateTBD(
        Number(id),
        tbd_presenters,
        tbd_moderators,
        tbd_supportstaff
      )
      const { data } = results
      if (data) {
        if (data.updateTBD.statusCode === 200) {
          // navigate('/event/dateAndTime/'+id);
        } else {
          showErrorPopup('Internal server error')
        }
      } else {
        showErrorPopup('Internal server error')
      }
    } catch (error) {
      showErrorPopup('Internal server error')
    }
  }

  const showErrorPopup = (message: string) => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 3000)
  }

  const nextClick = async () => {
    try {
      let presenters = staff.filter(
        (x: any) => x.staff_type === StaffType.PRESENTERS
      )
      let moderators = staff.filter(
        (x: any) => x.staff_type === StaffType.MODERATORS
      )

      let presenterErrorIndices: number[] = [],
        moderatorErrorIndices: number[] = []

      //Please add Moderator and Presenter information or select TBD.
      if (
        moderators.length === 0 &&
        !tbd_moderators &&
        presenters.length === 0 &&
        !tbd_presenters
      ) {
        showErrorPopup('Please add Moderator and Presenter information or select TBD.')
        return
      }

      // moderators validation
      if (moderators.length === 0 && !tbd_moderators) {
        showErrorPopup('Please add Moderator information or select TBD.')
        return
      }
      moderators.forEach((x: any, index: number) => {
        if (
          !x.name.trim() ||
          !x.email.trim() ||
          !x.phone.trim() ||
          !x.programOffice.trim() ||
          !x.jobTitle.trim() ||
          !new RegExp(/\S+@\S+\.\S+/).test(x.email) ||
          !new RegExp(/^\d+$/).test(x.phone) ||
          x.phone.length !== 10
        ) {
          moderatorErrorIndices.push(index)
        }
      })
      setModeratorErrors(moderatorErrorIndices)
      if (moderatorErrorIndices.length > 0) return

      // presenters validation
      if (presenters.length === 0 && !tbd_presenters) {
        showErrorPopup('Please add Presenter information or select TBD.')
        return
      }
      presenters.forEach((x: any, index: number) => {
        if (
          !x.name.trim() ||
          !x.email.trim() ||
          !x.programOffice.trim() ||
          !x.jobTitle.trim() ||
          !new RegExp(/\S+@\S+\.\S+/).test(x.email) ||
          (x.phone.trim() && (!new RegExp(/^\d+$/).test(x.phone) || x.phone.length !== 10))
        ) {
          presenterErrorIndices.push(index)
        }
      })
      setPresenterErrors(presenterErrorIndices)
      if (presenterErrorIndices.length > 0) return

      await updateTbd()
      const results = await createUpdateStaff(event.id, staff)
      const { data } = results
      if (data) {
        if (data.createUpdateStaff.statusCode === 200) {
          if (event.eventType === EventType.WEBINAR) navigate('/event/audience/' + event.id)
          else if (event.eventType === EventType.SERIES) navigate('/event/featuresAndRequests/' + event.id)
          else navigate('/event/dateAndTime/' + event.id)
        } else {
          showErrorPopup('Internal server error')
        }
      }
    } catch (error: any) {
      showErrorPopup('Internal server error')
    }
  }

  const saveExit = async () => {
    try {
      await updateTbd()
      await createUpdateStaff(event.id, staff)
      navigate('/')
    } catch (error: any) {
      navigate('/')
    }
  }

  return (
    <Box className='App' style={root}>
      <ProgressBar
        activePageTitle='Speakers & Staff'
        requestType={event.eventType}
      />

      <Item
        sx={{
          minHeight: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.02)'
        }}
      >
        <Box style={container}>
          <EventTitle title={event.title} />

          <Grid container>
            {showErrorMessage && (
              <Grid item xs={12} sm={12} md={12}>
                <ErrorMessage
                  message={showErrorMessage}
                  justifyContent='center'
                  icon={true}
                />
              </Grid>
            )}

            <Grid item sm={12} md={12} lg={5.5}>
              <Box className={classes.leftBlock}>
                <Box
                  sx={{
                    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                    my: '20px',
                    pb: '10px'
                  }}
                >
                  <Typography
                    align='left'
                    color='#565656'
                    sx={{
                      ml: { sm: '20px' },
                      fortWeight: '16px',
                      fontWeight: 400,
                      lineHeight: '24px',
                      letterSpacing: '0.5px'
                    }}
                  >
                    Please enter the names of people who are speaking,
                    presenting, or otherwise acting as support staff for this
                    event.
                  </Typography>
                </Box>
                <Box className={classes.accordian}>
                  <Box>
                    <Box sx={{ mb: 2 }}>
                      <AccordionComponent
                        title='Who should be added to this event?'
                        summary=' Any individuals from your office or organization who will be participating in your event should be added to your event. This includes speakers and presenters, moderators, and any supporting staff.'
                        panel='panel1'
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <AccordionComponent
                        title='Moderators'
                        summary='The DOL ETA Moderator is responsible for aiding and maintaining community standards and ethics for the duration of your event. Every event must have a DOL ETA Moderator listed for the event request to be approved.'
                        panel='panel2'
                      />
                    </Box>
                    <Box
                      sx={{
                        display: {
                          lg: 'none',
                          md: 'block',
                          sm: 'block',
                          xs: 'none'
                        }
                      }}
                    >
                      {' '}
                      <AccordionComponent
                        title='Additional Info'
                        summary=' Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                      eget.'
                        panel='panel5'
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <AccordionComponent
                        title='Speakers & Presenters'
                        summary='Speakers and Presenters are essential to the success of your event. Include any individuals who will be participating in a speaking or presentation capacity at any point during your event.'
                        panel='panel3'
                      />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                      <AccordionComponent
                        title='Support Staff'
                        summary='Support Staff includes individuals who are facilitating your activities and will be virtually present during your event. Any individuals from your office or contractor support who will aid in the presentation of your event and need access to the event’s presenter room should be accounted for as a member of the event Support Staff.'
                        panel='panel4'
                      />
                    </Box>
                    <Box sx={{ display: { md: 'none', sm: 'none' } }}>
                      {' '}
                      <AccordionComponent
                        title='Additional Info'
                        summary=' Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                      eget.'
                        panel='panel5'
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6.5} sx={{ mb: '70px' }}>
              <Box
                sx={{
                  px: { lg: '32px', md: '0px' },
                  py: { lg: '16px' },
                  width: '100%',
                  backgroundColor: { lg: '#ffffff', md: 'transparent' },
                  borderRadius: '40px'
                }}
              >
                <Box
                  sx={{
                    display: { lg: 'block', md: 'none', xs: 'none' },
                    pl: '20px'
                  }}
                >
                  <PageTitle
                    title='Speakers & Support Staff'
                    iconPath={SpeakersAndSupportStaff}
                  />
                  {event.eventType === EventType.SERIES && (
                    <Typography variant='body2' style={{ flex: 1 }}>
                      The staff entered here will be used for all events in the series.
                    </Typography>
                  )}
                </Box>

                <Box
                  sx={{ bgcolor: 'white' }}
                  key='Moderators'
                  className={classes.approver}
                >
                  <Approver
                    setTbdPresenters={setTbdPresenters}
                    setTbdModerators={setTbdModerators}
                    setTbdSupportstaff={setTbdSupportstaff}
                    eventData={event}
                    isRequired={true}
                    title='Moderators'
                    staff_type={StaffType.MODERATORS}
                    staff={staff}
                    onStaffChange={staff =>
                      handleStaffChange(staff, StaffType.MODERATORS)
                    }
                    staffErrors={moderatorErrors}
                    programOfficeId={event?.programOfficeId}
                  />
                </Box>
                <Box
                  sx={{ bgcolor: 'white' }}
                  key='Presenters'
                  className={classes.approver}
                >
                  <Approver
                    setTbdPresenters={setTbdPresenters}
                    setTbdModerators={setTbdModerators}
                    setTbdSupportstaff={setTbdSupportstaff}
                    eventData={event}
                    isRequired={true}
                    title='Presenters'
                    staff_type={StaffType.PRESENTERS}
                    staff={staff}
                    onStaffChange={staff =>
                      handleStaffChange(staff, StaffType.PRESENTERS)
                    }
                    staffErrors={presenterErrors}
                    programOfficeId={event?.programOfficeId}
                  />
                </Box>
                <Box
                  sx={{ bgcolor: 'white' }}
                  key='Support Staff'
                  className={classes.approver}
                >
                  <Approver
                    setTbdPresenters={setTbdPresenters}
                    setTbdModerators={setTbdModerators}
                    setTbdSupportstaff={setTbdSupportstaff}
                    eventData={event}
                    title='Support Staff'
                    staff_type={StaffType.SUPPORT_STAFF}
                    staff={staff}
                    onStaffChange={staff =>
                      handleStaffChange(staff, StaffType.SUPPORT_STAFF)
                    }
                    programOfficeId={event?.programOfficeId}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Footer
          saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Speakers & Staff'
          canMoveNext={true}
        />
      </Item>
    </Box>
  )
}
